<script lang="ts">
  import type { SvelteHTMLElements } from 'svelte/elements'

  type Props = {
    color?: string
  } & SvelteHTMLElements['svg']

  let { color = 'currentColor', ...restProps }: Props = $props()
</script>

<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" {...restProps}>
  <path
    d="M10 12h44a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4V16a4 4 0 0 1 4-4Zm0 4v8h44v-8H10Zm0 12v20h44V28H10Z"
    fill={color}
  />
  <path d="M24 26h4v24h-4V26Zm16 0h4v24h-4V26Z" fill={color} opacity="0.55" />
  <path
    d="M15 44a2 2 0 0 1-1.28-3.54l9.45-7.88a2 2 0 0 1 2.7.12l6.47 6.47 10.12-12.65a2 2 0 0 1 2.98-.16l5 5a2 2 0 0 1-2.83 2.83l-3.42-3.42-10.05 12.57a2 2 0 0 1-2.98.18l-6.6-6.6-8.28 6.9A2 2 0 0 1 15 44Z"
    fill={color}
  />
</svg>
